import style from "./Navigation.module.scss";
import Logo from "../../../images/logo.svg";
import React from "react";

interface NavigationProps {
    logo?: string;
    navigationRef: React.RefObject<HTMLDivElement | null>;
    supportNumber?: string;
}

const Navigation: React.FC<NavigationProps> = ({navigationRef, logo, supportNumber}) => {

    const scrollToSection = (ref: React.RefObject<HTMLDivElement | null>) => {
        ref.current?.scrollIntoView({behavior: 'smooth', block: 'start'});
    };

    return (
        <div className={style.navigation}>
            <img className={style.logo} src={process.env.REACT_APP_IMAGE_URL + (logo || '')} alt={"navigation logo"}></img>
            <div className={style.support}>
                <div className={style.numberContainer}>
                    <div className={style.number}>{supportNumber}</div>
                </div>
                <button className={style.redirectButton} onClick={() => {
                    scrollToSection(navigationRef)
                }}>
                    <div className={style.rbTextContainer}>
                        <div className={style.rbText}>
                            Оставить заявку
                        </div>
                    </div>
                </button>
            </div>
        </div>
    )
}

export default Navigation;